import styles from "./ErrorMessage.module.scss";
import CloseButton from "../../styles/icon/closeButton.svg";
export default function ErrorMessage({ setMessageBox, messageBox }) {
  return (
    <div>
      <div className={styles.containerForShowMessage}></div>
      <div className={styles.showMessageBox}>
        <div
          className={styles.closeMessageBox}
          onClick={() => setMessageBox("")}
        >
          <img src={CloseButton} alt="close" width={13} height={13} />
        </div>
        <div className={styles.textOfMessage}>{messageBox}</div>
      </div>
    </div>
  );
}
